import {Injectable} from '@angular/core';
import {UserService} from 'common-domain';
import {AuthService} from 'common-domain';
import {AppConfigService} from 'common-domain';
import {UserVO} from 'common-domain';

@Injectable({
  providedIn: 'root'
})
export class TermsAndPrivacyAcknowledgmentService {
  constructor(private userService: UserService, private authService: AuthService, private appConfigService: AppConfigService) {
  }

  get displayTermsAndPrivacyAcknowledgment(): boolean {
    const user: UserVO = this.authService.currentUserAuthVO();
    if (user === null) {
      return false;
    }
    if (user.termsAndPrivacyAcknowledgmentDate && user.loginName) {
      // Simple equality check - show prompt if acceptance date differs from current version
      return this.appConfigService.getTermsAndPrivacyVersion() !== user.termsAndPrivacyAcknowledgmentDate;
    }
    return true;
  }

  acknowledge(): void {
    this.userService.acknowledgeTerms().subscribe({
      next: _ => {
        // Backend returns 204 No Content, so we need to reload the user
        this.userService.getCurrentUser().subscribe({
          next: (updatedUser) => {
            // Store the updated user in localStorage and update the BehaviorSubject
            this.authService.storeUserAuthVO(updatedUser);
          }
        });
      },
      error: (error) => {
        // Handle errors gracefully - log but don't crash
        console.error('Error acknowledging terms:', error);
      }
    });
  }
}
